import { render, staticRenderFns } from "./CollapsePanelBigLink.vue?vue&type=template&id=8d0dd2b4&scoped=true"
import script from "./CollapsePanelBigLink.vue?vue&type=script&lang=js"
export * from "./CollapsePanelBigLink.vue?vue&type=script&lang=js"
import style0 from "./CollapsePanelBigLink.vue?vue&type=style&index=0&id=8d0dd2b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0dd2b4",
  null
  
)

export default component.exports